import { TENANT_GOVERNANCE_PERMISSION_GROUPS } from "../constants/tenantGovernancePermissions";

export const TENANT_ADMIN_EXPLICIT_PERMISSION_KEYS = [
  ...TENANT_GOVERNANCE_PERMISSION_GROUPS.settingsView,
  ...TENANT_GOVERNANCE_PERMISSION_GROUPS.settingsUpdate,
  ...TENANT_GOVERNANCE_PERMISSION_GROUPS.companyDetailsView,
  ...TENANT_GOVERNANCE_PERMISSION_GROUPS.companyDetailsUpdate,
  ...TENANT_GOVERNANCE_PERMISSION_GROUPS.modulesView,
  ...TENANT_GOVERNANCE_PERMISSION_GROUPS.modulesUpdate,
  ...TENANT_GOVERNANCE_PERMISSION_GROUPS.workflowsView,
  ...TENANT_GOVERNANCE_PERMISSION_GROUPS.workflowsUpdate,
  ...TENANT_GOVERNANCE_PERMISSION_GROUPS.integrationsView,
  ...TENANT_GOVERNANCE_PERMISSION_GROUPS.integrationsUpdate,
  ...TENANT_GOVERNANCE_PERMISSION_GROUPS.statusView,
  ...TENANT_GOVERNANCE_PERMISSION_GROUPS.documentsView,
  ...TENANT_GOVERNANCE_PERMISSION_GROUPS.documentsCreate,
  ...TENANT_GOVERNANCE_PERMISSION_GROUPS.documentsUpdate,
  ...TENANT_GOVERNANCE_PERMISSION_GROUPS.documentsArchive,
  ...TENANT_GOVERNANCE_PERMISSION_GROUPS.usersManage,
  ...TENANT_GOVERNANCE_PERMISSION_GROUPS.rolesManage,
];

export function getRoleNames(user) {
  const set = new Set();
  const direct = [user?.rol, user?.role];
  for (const value of direct) {
    if (!value) continue;
    set.add(String(value).trim().toLowerCase());
  }

  for (const role of Array.isArray(user?.roles) ? user.roles : []) {
    if (!role) continue;
    if (typeof role === "string") {
      set.add(role.trim().toLowerCase());
      continue;
    }
    const name = role?.name || role?.naam;
    if (name) set.add(String(name).trim().toLowerCase());
  }

  if (set.has("zzp_owner")) {
    set.add("tenantadmin");
    set.add("projectleider");
  }

  return Array.from(set);
}

export function getPermissionSet(user) {
  return new Set(
    (Array.isArray(user?.permissions) ? user.permissions : [])
      .map((value) => String(value || "").trim().toLowerCase())
      .filter(Boolean)
  );
}

export function hasAnyPermission(user, permissionKeys = []) {
  const permissionSet = getPermissionSet(user);
  return (Array.isArray(permissionKeys) ? permissionKeys : []).some((key) =>
    permissionSet.has(String(key || "").trim().toLowerCase())
  );
}

export function canAccessTenantAdmin(user) {
  const roleNames = new Set(getRoleNames(user));
  if (roleNames.has("platformadmin") || roleNames.has("tenantadmin")) {
    return true;
  }

  if (roleNames.has("projectleider")) {
    return hasAnyPermission(user, TENANT_ADMIN_EXPLICIT_PERMISSION_KEYS);
  }

  return false;
}
